module.exports = __webpack_public_path__ + "media/images/avatar-male-big-157dd8240be2d977f672fedc5df5d58b.svg";